export default {
    state: {
        authtoken: localStorage.getItem("authtoken"),
        userData: JSON.parse(localStorage.getItem("userData")) || {},
        company: JSON.parse(localStorage.getItem("company")) || {}
    },
    getters: {
        authtoken: state => state.authtoken,
        userId: (state) => state.userData._id,
        userName: (state) => state.userData.realname,
        userAvatar: (state) => state.userData.avatarurl,
        userType: (state) => state.userData.user_type,
        mobile: (state) => state.userData.mobile,

        companyName: (state) => state.company.name,
        companyId: (state) => state.company.companyId,
        companyType: (state) => state.company.companyType,
        isAdmin: (state) => state.company.isAdmin
    },
    mutations: {
        updateUserData (state, userData) {
            state.userData = userData || {};
            localStorage.setItem("userData", JSON.stringify(state.userData));
        },
        updateAuthtoken (state, authtoken) {
            state.authtoken = authtoken;
            if (authtoken) {
                localStorage.setItem("authtoken", authtoken);
            } else {
                localStorage.removeItem("authtoken");
            }

        },
        updateCompany (state, company) {
            company = company || {};
            let storyCompany = {
                name: company.name,
                companyId: company._id,
                companyType: company.company_type,
                isAdmin: company.__isAdmin__
            };

            state.company = storyCompany;
            localStorage.setItem("company", JSON.stringify(storyCompany));
        }
    },
    actions: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/userCompany.js